/**
 * TanStack Router: /vacation/overview
 *
 * This route file was auto-generated by the route generation script.
 * Component: VacationOverviewPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import VacationOverviewPage from '@/app/vacation/overview/page'

/**
 * Route: /vacation/overview
 * Layout: _auth (authenticated)
 * Component: VacationOverviewPage
 */
export const Route = createFileRoute('/_auth/vacation/overview')({
  component: VacationOverviewPage,
})
